import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SortBtnsEvent } from '../../../core/classes/sort-btns-event';
import { EventPoolService } from '../../../core/event-pool.service';

@Component({
  selector: 'rl-sort-buttons',
  templateUrl: './sort-buttons.component.html',
  styleUrls: ['./sort-buttons.component.scss']
})
export class SortButtonsComponent implements OnInit, OnDestroy {

  @Input() dir? : 'asc' | 'desc' | '' = '';
  @Input() group : string;  
  @Input() name : string;

  @Output() onSort = new EventEmitter<'asc' | 'desc'>();

  epSub : Subscription;

  constructor(private ep : EventPoolService) { }

  ngOnInit(): void {
    this.epSub = this.ep.sortBtnsListener$.subscribe(this.updateDir);
  }

  sort(dir : 'asc' | 'desc'){
    if(this.dir == '') this.ep.update(new SortBtnsEvent(this.group, this.name));
    this.dir= dir;
    this.onSort.emit(this.dir);
  }

  updateDir = (e : SortBtnsEvent) => this.dir = (e.group == this.group && e.name != this.name) ? '' : this.dir;

  ngOnDestroy(): void {
    this.epSub.unsubscribe();
  }
}
